var antPrefixCls = '.ant-app';
var genBaseStyle = function genBaseStyle(token) {
  var _ref;
  var colorText = token.colorText,
    fontSize = token.fontSize,
    lineHeight = token.lineHeight,
    fontFamily = token.fontFamily;
  return _ref = {}, _ref[antPrefixCls] = {
    color: colorText,
    fontSize: fontSize,
    lineHeight: lineHeight,
    fontFamily: fontFamily
  }, _ref;
};
var appStyleFn = function appStyleFn(token) {
  return genBaseStyle(token);
};

export { appStyleFn };
